<div id="popup-modal" tabindex="-1" class="overflow-y-auto overflow-x-hidden top-0 right-0 left-0 z-50 md:inset-0 h-modal md:h-full">
  <div class="relative w-[332px] lg:w-[960px] h-full">
    <div class="relative bg-neutral-06 rounded-lg shadow dark:bg-gray-700">
      <div
        (click)="onClose()"
        class="absolute z-50 cursor-pointer top-1 right-4 lg:top-4 focus:boder-0 lg:right-4 text-gray-400 bg-transparent hover:bg-gray-200
          hover:text-gray-900 rounded-lg text-sm p-2 ml-auto inline-flex items-center"
        data-modal-toggle="popup-modal"
      >
        <svg
          class="text-neutral-06 stroke-white hidden lg:block"
          width="32"
          stroke="currentColor"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M27.0635 5.49365L5.23599 28.4268" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
          <path d="M27.0635 28.4269L5.23599 5.49369" stroke="#666" stroke-width="1.5" stroke-linecap="round" />
        </svg>
        <span class="sr-only">Close modal</span>
      </div>

      <div class="">
        <div class="lg:flex relative">
          <div class="relative">
            <form *ngIf="registerForm" [formGroup]="registerForm" class="md:flex" autocomplete="off">
              <div class="bg-neutral-06 md:w-[400px]">
                <img class="md:hidden" src="/assets/images/register-header-mobile.png" alt="register-header-mobile" loading="lazy" />
                <img
                  class="hidden md:block h-100 max-w-none"
                  src="/assets/images/register-header.png"
                  alt="register-header"
                  loading="lazy"
                />
              </div>

              <div class="p-5 bg-neutral-06 md:px-16 md:max-h-max overflow-auto max-h-[500px]">
                <p class="text-xl md:text-4xl md:leading-[44px] text-primary font-bold">
                  {{ 'REGISTER_POPUP_TITLE' | translate }}
                </p>
                <p class="mt-2 text-sm text-neutral-01">
                  {{ 'REGISTER_POPUP_SUB_TITLE' | translate }}
                </p>
                <hr class="my-4" />

                <ng-container *ngIf="registerForm.get('name') as nameControl">
                  <p class="text-sm font-bold md:font-semibold text-neutral-01">
                    {{ 'REGISTER_POPUP_INPUT_NAME' | translate }}
                  </p>
                  <input
                    type="text"
                    formControlName="name"
                    autocomplete="off"
                    class="mt-1 bg-neutral-14 w-full border border-neutral-17 py-3 px-4 text-sm"
                    [class.border-primary]="nameControl.invalid && nameControl.touched"
                    placeholder="Nguyễn Văn A"
                  />
                  <p [class.invisible]="!nameControl.invalid || !nameControl.touched" class="text-xs text-danger text-right mt-1">
                    {{ 'REGISTER_POPUP_INPUT_NAME_ERR' | translate }}
                  </p>
                </ng-container>

                <ng-container *ngIf="registerForm.get('email') as emailControl">
                  <p class="text-sm font-bold md:font-semibold text-neutral-01">
                    {{ 'REGISTER_POPUP_INPUT_EMAIL' | translate }}
                  </p>
                  <input
                    type="email"
                    formControlName="email"
                    autocomplete="off"
                    class="mt-1 bg-neutral-14 w-full border border-neutral-17 py-3 px-4 text-sm"
                    [class.border-primary]="emailControl.invalid && emailControl.touched"
                    placeholder="nguyenvana@gmail.com"
                  />
                  <p [class.invisible]="!emailControl.invalid || !emailControl.touched" class="text-xs text-danger text-right mt-1">
                    {{ 'REGISTER_POPUP_INPUT_EMAIL_ERR' | translate }}
                  </p>
                </ng-container>

                <ng-container *ngIf="registerForm.get('phone') as phoneControl">
                  <p class="text-sm font-bold md:font-semibold text-neutral-01">
                    {{ 'REGISTER_POPUP_INPUT_PHONE' | translate }}
                  </p>
                  <input
                    type="text"
                    formControlName="phone"
                    autocomplete="off"
                    class="mt-1 bg-neutral-14 w-full border border-neutral-17 py-3 px-4 text-sm"
                    [class.border-primary]="phoneControl.invalid && phoneControl.touched"
                    placeholder="0909 123 456"
                  />
                  <p [class.invisible]="!phoneControl.invalid || !phoneControl.touched" class="text-xs text-danger text-right mt-1">
                    {{ 'REGISTER_POPUP_INPUT_PHONE_ERR' | translate }}
                  </p>
                </ng-container>

                <ng-container *ngIf="registerForm.get('services') as servicesControl">
                  <p class="text-sm font-bold md:font-semibold text-neutral-01">
                    {{ 'REGISTER_POPUP_INPUT_SERVICES' | translate }}
                  </p>
                  <div
                    [class.border-primary]="servicesControl.invalid && servicesControl.touched"
                    class="select-wrapper focus:border-blue border border-neutral-17"
                  >
                    <app-select-box
                      tabindex="0"
                      [list]="listServiceAvailable"
                      formControlName="services"
                      [placeholder]="currentLanguage === 'vi' ? 'Dịch vụ' : 'Services'"
                      (change)="onChangeServices($event)"
                    ></app-select-box>
                  </div>
                  <p [class.invisible]="!servicesControl.invalid || !servicesControl.touched" class="text-xs text-danger text-right mt-1">
                    {{ 'REGISTER_POPUP_INPUT_SERVICES_ERR' | translate }}
                  </p>
                </ng-container>

                <ng-container *ngIf="registerForm.get('content') as contentControl">
                  <p class="text-sm font-bold md:font-semibold text-neutral-01">
                    {{ 'REGISTER_POPUP_INPUT_CONTENT' | translate }}
                  </p>
                  <textarea
                    formControlName="content"
                    autocomplete="off"
                    rows="4"
                    class="mt-1 bg-neutral-14 w-full border border-neutral-17 py-3 px-4 text-sm h-[88px]"
                    [class.border-primary]="contentControl.invalid && contentControl.touched"
                    placeholder="{{ 'REGISTER_POPUP_INPUT_CONTENT_EXAMPLE' | translate }}"
                  >
                  </textarea>
                  <p [class.invisible]="!contentControl.invalid || !contentControl.touched" class="text-xs text-danger text-right mt-1">
                    {{ 'REGISTER_POPUP_INPUT_CONTENT_ERR' | translate }}
                  </p>
                </ng-container>

                <div class="flex justify-center md:justify-end md:mt-5">
                  <button class="bg-primary color-white font-medium flex items-center py-3 px-8" (click)="register()">
                    {{ 'REGISTER_POPUP_SUBMIT' | translate }}
                    <img class="ml-3" src="/assets/svg/ic-arrow-right.svg" alt="ic-arrow-right" loading="lazy" />
                  </button>
                </div>
              </div>

              <button type="submit" class="absolute right-4 top-4" (click)="onClose()">
                <svg width="31" height="33" viewBox="0 0 31 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M26.5684 4.97998L4.74087 27.9132" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                  <path d="M26.5684 27.9131L4.74088 4.97989" stroke="white" stroke-width="1.5" stroke-linecap="round" />
                </svg>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
